import api from "!../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.111.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/.pnpm/mini-css-extract-plugin@1.6.2_webpack@5.111.0/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-2.use[2]!../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.111.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-2.use[3]!../../node_modules/.pnpm/postcss-loader@4.3.0_postcss@8.5.28_webpack@5.111.0/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-2.use[4]!../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.104.1_webpack@5.111.0/node_modules/sass-loader/dist/cjs.js!./theme.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};